import { render, staticRenderFns } from "./shopScmSupplier.vue?vue&type=template&id=3d56a743&scoped=true&"
import script from "./shopScmSupplier.vue?vue&type=script&lang=js&"
export * from "./shopScmSupplier.vue?vue&type=script&lang=js&"
import style0 from "./shopScmSupplier.vue?vue&type=style&index=0&id=3d56a743&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d56a743",
  null
  
)

export default component.exports